import { render, staticRenderFns } from "./NavigationDrawerContent.vue?vue&type=template&id=3e71d70d&scoped=true&"
import script from "./NavigationDrawerContent.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71d70d",
  null
  
)

export default component.exports